import { Component } from '@angular/core';

@Component({
    template: `<div></div>`
})
export class DummyComponent {

}
